import { FAIcon } from '@nextgen-web-framework/all';
import styles from './AddToListToggleLoader.module.scss';

export const AddToListToggleLoader = () => (
  <div className={styles['heart-icon-loader']}>
    <FAIcon iconName="spinner-third" />
  </div>
);
